const KL_NOTIFY_ME_TRIGGER_SELECTOR = '[data-kl-notify-me-trigger]';
const KL_NOTIFY_ME_FORM_SELECTOR = '[data-kl-notify-me]';
const KL_NOTIFY_ME_SWAP_SELECTOR = '[data-kl-notify-me-swap]';

const KL_NOTIFY_ME_SUCCESS_CLASS = 'is-success';
const KL_NOTIFY_ME_ERROR_CLASS = 'is-error';
const KL_NOTIFY_ME_SOLD_OUT_CLASS = 'is-sold-out';
const KL_NOTIFY_ME_BUSY_CLASS = 'is-busy';

const KL_NOTIFY_ME_EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const KL_NOTIFY_ME_CLOSE_DELAY = 1500;

const KL_NOTIFY_ME_SUBSCRIBED_EVENT = 'kl:notify-me:subscribed';
const KL_NOTIFY_ME_API_TOKEN = 'pk_aba30ebde8ac85f72cf7a74142b1232cd8';

let klNotifyMeOpenContext = {};

function klNotifyMeNormalizeVariantId(variantValue) {
  const variantText = String(variantValue || '').trim();

  return variantText.slice(variantText.lastIndexOf('/') + 1);
}

function klNotifyMeIsEmailValid(emailValue) {
  return KL_NOTIFY_ME_EMAIL_PATTERN.test(String(emailValue || '').trim());
}

async function klNotifyMeSubscribe(endpointUrl, emailValue, variantId) {
  const response = await fetch(endpointUrl, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      revision: "2024-10-15",
      Authorization: `Klaviyo-API-Key ${KL_NOTIFY_ME_API_TOKEN}`,
    },
    body: JSON.stringify({
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: { type: "profile", attributes: { email: emailValue } },
            },
            channels: ["EMAIL"],
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${variantId}`,
              },
            },
          },
        },
      }),
  });

  return response;
}

function klNotifyMeShowMessage(messageElement, messageText, isSuccess) {
  if (!messageElement) return;

  messageElement.textContent = messageText;
  messageElement.classList.toggle(KL_NOTIFY_ME_SUCCESS_CLASS, isSuccess);
  messageElement.classList.toggle(KL_NOTIFY_ME_ERROR_CLASS, !isSuccess);
  messageElement.hidden = false;
}

function klNotifyMeClearMessage(messageElement) {
  if (!messageElement) return;

  messageElement.textContent = '';
  messageElement.classList.remove(KL_NOTIFY_ME_SUCCESS_CLASS, KL_NOTIFY_ME_ERROR_CLASS);
  messageElement.hidden = true;
}

function klNotifyMeReadContext(trigger) {
  const data = trigger.dataset;

  return {
    productId: data.klNotifyMeProductId || '',
    productTitle: data.klNotifyMeProductTitle || '',
    productHandle: data.klNotifyMeProductHandle || '',
    productUrl: data.klNotifyMeProductUrl || '',
    productImage: data.klNotifyMeProductImage || '',
    priceCents: data.klNotifyMePriceCents || '',
    currency: data.klNotifyMeCurrency || '',
  };
}

function klNotifyMePublishSubscribed(emailValue, variantId) {
  document.dispatchEvent(
    new CustomEvent(KL_NOTIFY_ME_SUBSCRIBED_EVENT, {
      detail: Object.assign({}, klNotifyMeOpenContext, { email: emailValue, variantId }),
    })
  );
}

function klNotifyMeInitForm(form) {
  const emailInput = form.querySelector('[data-kl-notify-me-email]');
  const variantInput = form.querySelector('[data-kl-notify-me-variant]');
  const submitButton = form.querySelector('[data-kl-notify-me-submit]');
  const messageElement = form.querySelector('[data-kl-notify-me-message]');
  const dialog = form.closest('dialog');

  if (!emailInput || !variantInput || !submitButton) return;

  const endpointUrl = form.dataset.klNotifyMeEndpoint;
  const successText = form.dataset.klNotifyMeSuccess;
  const errorText = form.dataset.klNotifyMeError;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    const emailValue = emailInput.value.trim();

    if (!klNotifyMeIsEmailValid(emailValue)) {
      klNotifyMeShowMessage(messageElement, emailInput.validationMessage || errorText, false);
      emailInput.focus();
      return;
    }

    if (!endpointUrl) {
      klNotifyMeShowMessage(messageElement, errorText, false);
      console.debug('kl-notify-me: no endpoint on the form', { form });
      return;
    }

    klNotifyMeClearMessage(messageElement);
    form.classList.add(KL_NOTIFY_ME_BUSY_CLASS);
    submitButton.disabled = true;

    const variantId = klNotifyMeNormalizeVariantId(variantInput.value);

    try {
      const response = await klNotifyMeSubscribe(endpointUrl, emailValue, variantId);

      if (response.ok) {
        klNotifyMeShowMessage(messageElement, successText, true);
        klNotifyMePublishSubscribed(emailValue, variantId);
        setTimeout(() => dialog?.close(), KL_NOTIFY_ME_CLOSE_DELAY);
        return;
      }
      
      const responseData = await response.json();
      if (responseData && responseData.success) {
        klNotifyMeShowMessage(messageElement, successText, true);
        klNotifyMePublishSubscribed(emailValue, variantId);
        setTimeout(() => dialog?.close(), KL_NOTIFY_ME_CLOSE_DELAY);
      } else {
        klNotifyMeShowMessage(messageElement, responseData?.message || errorText, false);
      }
    } catch (error) {
      klNotifyMeShowMessage(messageElement, errorText, false);
      console.debug('kl-notify-me: the subscribe request failed', { endpointUrl, error });
    } finally {
      form.classList.remove(KL_NOTIFY_ME_BUSY_CLASS);
      submitButton.disabled = false;
    }
  });

  dialog?.addEventListener('close', () => {
    form.reset();
    klNotifyMeClearMessage(messageElement);
  });
}

function klNotifyMeParseVariantIds(variantIdList) {
  return String(variantIdList || '')
    .split(',')
    .map((variantId) => variantId.trim())
    .filter(Boolean);
}

function klNotifyMeIsVariantNotifiable(notifiableVariantIds, variantValue) {
  const variantId = klNotifyMeNormalizeVariantId(variantValue);

  if (!variantId) return false;

  return notifiableVariantIds.indexOf(variantId) !== -1;
}

function klNotifyMeUpdateSwap(swap, variantValue) {
  const trigger = swap.querySelector(KL_NOTIFY_ME_TRIGGER_SELECTOR);

  if (!trigger) return;

  const notifiableVariantIds = klNotifyMeParseVariantIds(swap.dataset.klNotifyMeVariantIds);
  const zeroPreOrder = swap.dataset.klNotifyMeZeroPreOrder === 'true';

  swap.classList.toggle(
    KL_NOTIFY_ME_SOLD_OUT_CLASS,
    zeroPreOrder || klNotifyMeIsVariantNotifiable(notifiableVariantIds, variantValue)
  );

  if (variantValue) trigger.dataset.klNotifyMeVariantId = variantValue;
}

function klNotifyMeUpdateSwapsForInput(variantInput) {
  document.querySelectorAll(KL_NOTIFY_ME_SWAP_SELECTOR).forEach((swap) => {
    const formId = swap.dataset.klNotifyMeFormId;

    if (formId && variantInput.form?.id !== formId) return;

    klNotifyMeUpdateSwap(swap, variantInput.value);
  });
}

function klNotifyMeInitSwap(swap) {
  const productForm = document.getElementById(swap.dataset.klNotifyMeFormId || '');

  const variantInput = productForm?.querySelector('input[name="id"]');

  if (!variantInput) return;

  klNotifyMeUpdateSwap(swap, variantInput.value);
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest(KL_NOTIFY_ME_TRIGGER_SELECTOR);

  if (!trigger) return;

  const dialog = document.getElementById(trigger.dataset.klDialogOpen || '');
  const variantInput = dialog?.querySelector('[data-kl-notify-me-variant]');

  if (!variantInput) {
    console.debug('kl-notify-me: the trigger has no dialog to fill', { trigger });
    return;
  }

  variantInput.value = trigger.dataset.klNotifyMeVariantId || '';
  klNotifyMeOpenContext = klNotifyMeReadContext(trigger);
});

document.addEventListener('change', (event) => {
  const variantInput = event.target;

  if (!variantInput || variantInput.name !== 'id' || variantInput.tagName !== 'INPUT') return;

  klNotifyMeUpdateSwapsForInput(variantInput);
});

document.querySelectorAll(KL_NOTIFY_ME_FORM_SELECTOR).forEach(klNotifyMeInitForm);
document.querySelectorAll(KL_NOTIFY_ME_SWAP_SELECTOR).forEach(klNotifyMeInitSwap);
